<script>
    import {getStyleValue} from "../../Common/tools";
    import TextEditor from "../../Common/TextEditor.svelte";
    import Button from "./Button.svelte";
    import Image from "./Image.svelte";

    export let data, meta, globalStyle, onChange;

    function change(val) {
      onChange();
      data = Object.assign({}, data, {content: val});
    }
</script>

<tr>
    <th class="column" style="padding-left: 30px; padding-right: 30px; font-weight: 400;"
        width="{getStyleValue(globalStyle.width, 600)}">
        <div class="spacer" style="font-size: 30px; line-height: 30px;">&nbsp;</div>
        <TextEditor data={data.content} meta={meta} onChange={change} emailEditor={true} />
        <center>
            <Button bind:data={data} meta={meta} globalStyle={globalStyle} isChild={true} onChange={onChange}/>
            <div class="spacer" style="font-size: 35px; line-height: 35px;">&nbsp;</div>
            <div>
                <Image data={data} meta={meta} globalStyle={globalStyle} placeholderSize="310x300" isChild={true}/>
            </div>
        </center>
    </th>
</tr>
